import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "FormHeadingBlock",
  props: {
    value: {
      prop: "other",
      type: "string",
      value: "Form Heading",
    },
    textType: {
      prop: "other",
      type: "select",
      value: "title",
      options: [
        { label: "Title", value: "title" },
        { label: "Subtitle", value: "subtitle" },
      ],
    },
  },
};
